(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["batanova-faydalar"] && !Shopify.designMode) return;
  try {
    (function () {
    function kur(kok) {
      (kok || document).querySelectorAll('[data-bt-faydalar]:not(.is-gorunur)').forEach(function (el) {
        if (!('IntersectionObserver' in window)) return el.classList.add('is-gorunur');
        var io = new IntersectionObserver(function (g) {
          if (g[0].isIntersecting) { el.classList.add('is-gorunur'); io.disconnect(); }
        }, { threshold: 0.2 });
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); });
    else kur();
    document.addEventListener('shopify:section:load', function (e) { kur(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["batanova-paket"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bt-paket')) {
    class BtPaket extends HTMLElement {
      connectedCallback() {
        this.sayacKur();
        this.addEventListener('change', (e) => {
          const r = e.target.closest('input[type="radio"]');
          if (!r) return;
          this.querySelectorAll('.bt-paket__kart').forEach((k) => k.classList.toggle('is-secili', k.contains(r)));
          const kapsam = this.closest('.product-information') || document;
          kapsam.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((g) => {
            g.value = r.value;
          });
          kapsam.querySelectorAll('.product-details [ref="priceContainer"] .price').forEach((f) => {
            f.textContent = r.dataset.fiyat;
          });
          document.querySelectorAll('.sticky-add-to-cart__price').forEach((f) => {
            f.textContent = r.dataset.fiyat;
          });
          document.querySelectorAll('.sticky-add-to-cart__variant').forEach((f) => {
            f.textContent = r.dataset.ad;
          });
          const url = new URL(window.location.href);
          url.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', url);
        });
      }
    }
    BtPaket.prototype.sayacKur = function () {
      const sayac = this.querySelector('[data-paket-sayac]');
      if (!sayac) return;
      const baslik = this.querySelector('[data-paket-baslik]');
      const kalanEl = sayac.querySelector('[data-kalan]');
      // Bitiş: ISO tarih (meta alanı) ya da "YYYY-AA-GG SS:DD" (Türkiye saati)
      let ham = (sayac.dataset.bitis || '').trim();
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(ham)) ham = ham.replace(' ', 'T') + ':00+03:00';
      const bitis = new Date(ham).getTime();
      if (isNaN(bitis)) return;
      const iki = (n) => String(n).padStart(2, '0');
      const guncelle = () => {
        const kalan = Math.floor((bitis - Date.now()) / 1000);
        if (kalan <= 0) {
          sayac.hidden = true;
          if (baslik) baslik.hidden = false;
          clearInterval(this.sayacZ);
          return;
        }
        const s = Math.floor(kalan / 3600);
        kalanEl.textContent = (s > 0 ? iki(s) + ':' : '') + iki(Math.floor((kalan % 3600) / 60)) + ':' + iki(kalan % 60);
        sayac.hidden = false;
        if (baslik) baslik.hidden = true;
      };
      guncelle();
      this.sayacZ = setInterval(guncelle, 1000);
    };
    customElements.define('bt-paket', BtPaket);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["batanova-puan"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-bt-puan]');
    if (!a) return;
    const hedef = document.querySelector(a.getAttribute('href'));
    if (!hedef) return;
    e.preventDefault();
    hedef.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["batanova-sosyal-kanit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bt-sosyal-kanit')) {
    class BtSosyalKanit extends HTMLElement {
      connectedCallback() {
        const m = Array.from(this.querySelectorAll('.bt-sosyal__mesaj'));
        if (m.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let i = 0;
        this.z = setInterval(() => {
          m[i].classList.remove('is-aktif');
          m[i].setAttribute('aria-hidden', 'true');
          i = (i + 1) % m.length;
          m[i].classList.add('is-aktif');
          m[i].removeAttribute('aria-hidden');
        }, Number(this.dataset.sure) || 4000);
      }
      disconnectedCallback() {
        clearInterval(this.z);
      }
    }
    customElements.define('bt-sosyal-kanit', BtSosyalKanit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["batanova-stok"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bt-teslimat')) {
    class BtTeslimat extends HTMLElement {
      connectedCallback() {
        this.tarihleriYaz();
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-gorunur');
          return;
        }
        this.io = new IntersectionObserver((g) => {
          if (g[0].isIntersecting) {
            this.classList.add('is-gorunur');
            this.io.disconnect();
          }
        }, { threshold: 0.4 });
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }

      tarihleriYaz() {
        const hazirlik = Number(this.dataset.hazirlik) || 2;
        const min = Number(this.dataset.min) || 2;
        const max = Number(this.dataset.max) || 4;

        // Türkiye saatine göre bugün
        const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const al = (t) => Number(p.find((x) => x.type === t).value);
        const bugun = new Date(al('year'), al('month') - 1, al('day'));

        const isGunu = (d) => d.getDay() !== 0 && d.getDay() !== 6;
        const ekle = (d, n) => {
          const s = new Date(d);
          let k = 0;
          while (k < n) {
            s.setDate(s.getDate() + 1);
            if (isGunu(s)) k++;
          }
          return s;
        };

        const hazir = ekle(bugun, hazirlik);
        const ilk = ekle(hazir, min);
        const son = ekle(hazir, max);
        const gunAy = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'short' });
        const gun = new Intl.DateTimeFormat('tr-TR', { day: 'numeric' });

        const yaz = (anahtar, metin) => {
          const el = this.querySelector(`[data-tarih="${anahtar}"]`);
          if (el) el.textContent = metin;
        };
        yaz('hazir', gunAy.format(hazir));
        yaz('teslim', (ilk.getMonth() === son.getMonth() ? gun.format(ilk) : gunAy.format(ilk)) + '–' + gunAy.format(son));
      }
    }
    customElements.define('bt-teslimat', BtTeslimat);
  }
  } catch(e) { console.error(e); }
})();

})();
